import React from 'react';
import { PanelMenu } from 'primereact/panelmenu';
const SideNavWithPanel = ({ items, className = "body-static-height" }) => {
    return (React.createElement("div", { className: className },
        React.createElement(PanelMenu, { model: items, style: { width: '100%' }, className: "pl-2" })));
};
export default SideNavWithPanel;
